"use client";

import { useSectionContext } from "@/hooks/use-section-context";
import { useWorkspaceNavigation } from "@/hooks/use-workspace-navigation";
import { buildAppLinks, buildProjectLinks, buildWorkspaceSections } from "@/lib/navigation/leaves";

import { useSelectedLayoutSegments } from "next/navigation";
import { NavLinkList } from "./nav-link-list";

export function SidebarBody() {
  return <NavLinkList links={useNavLinks()} />;
}

/** The links for wherever the user is: workspace, project or app. */
export function useNavLinks() {
  const context = useSectionContext();
  // useSelectedLayoutSegments includes route groups like "(project)"; strip
  // them so the index-based page lookups in leaves.ts stay stable.
  const segments = useSelectedLayoutSegments()
    .slice(1)
    .filter((segment) => !segment.startsWith("("));
  const { slug } = useWorkspaceNavigation();

  const workspaceSections = (segs: string[]) => buildWorkspaceSections(slug, segs);

  const links = (() => {
    switch (context.type) {
      case "workspace":
      // Settings and Authorization keep the top-level workspace nav in the
      // global sidebar; their sub-pages live in a SecondaryNav rail (see the
      // settings/authorization layouts).
      case "account":
      case "settings":
        return workspaceSections(segments);
      case "project":
        return context.appId
          ? buildAppLinks(slug, context.projectId, context.appId, segments)
          : buildProjectLinks(slug, context.projectId, segments);
    }
  })();

  return links;
}
